import type { ElibooApp, Result } from '@eliboo/api-models';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { getEnv } from '@env';

@Injectable({
  providedIn: 'root',
})
export class CcaseTransferSmsService {
  http = inject(HttpClient);
  env = getEnv();

  transferSMSCode(body: ElibooApp.TransferSMSCodeVO, signature: string) {
    return this.http.post<Result<boolean>>(`${this.env.baseUrl}eliboo-app-boot/app-api/v1/businessLicenseInfoSheet/transferSMSCode`, body, {
      observe: 'body',
      headers: { signature: signature },
    });
  }
}
